import { useEffect, useState } from 'react';
import { FaYoutube } from 'react-icons/fa';
import { HiEye } from 'react-icons/hi';

const CHANNEL_ID = 'UClvsyB_GQ0ozgVOmxrjYMxg';
const FEED_URL = `https://www.youtube.com/feeds/videos.xml?channel_id=${CHANNEL_ID}`;

const FALLBACK_SHORTS = [
  { id: '5qWFl1worXE', title: 'QUADS and the best possible runout!', views: 1025 },
  { id: '2xYr5fdhEE4', title: 'You’ve heard of JIGGITIES, BUT HAVE YOU HEARD!!?!?', views: 27605 },
  { id: 'WWQAUJt1I2c', title: 'Sometime you gotta just hero call...', views: 65946 },
  { id: 'pAn0zfzbe-o', title: 'The Best River we could have hoped for!', views: 725639 },
  { id: '6ZlAvpFO0nE', title: 'Ace Queen in this spot never ends well...', views: 242215 },
  { id: '5io9h88ne6c', title: 'POCKET QUIGGITIES in a sick one!', views: 325058 },
  { id: 'bMTMupENZEY', title: 'LIE TO ME', views: 259927 },
  { id: 'Uu_B5lJYBag', title: 'Was she just bluffing the whole time?', views: 197015 },
  { id: 'fHaCIzyVWYY', title: 'Bogdanoff!!!', views: 369324 },
  { id: 'ySNi5EV-pbw', title: 'Would you have raised this River with Aces?', views: 263516 },
  { id: 'J98IiiweA-E', title: 'Should\'ve known better against the river donk...', views: 78317 },
  { id: 'JIWQiErWkOs', title: 'What do you think he had here?', views: 202744 },
  { id: 'Bj4lSAhgbgI', title: 'Can we get there?', views: 220256 },
  { id: 'ueMSIByGnpY', title: 'Flopping QUADS and a slow roll!', views: 293588 },
  { id: 'tIPPuYVWpyk', title: 'It doesn\'t get much better than this!', views: 582884 },
];

function formatViews(count) {
  const n = Number(count) || 0;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
  return `${n}`;
}

function parseFeed(xml) {
  const doc = new DOMParser().parseFromString(xml, 'text/xml');
  return [...doc.querySelectorAll('entry')].map((entry) => {
    const id = entry.querySelector('videoId')?.textContent
      || entry.getElementsByTagName('yt:videoId')[0]?.textContent;
    const title = (entry.querySelector('title')?.textContent || '')
      .replace(/\s*#shorts\s*#poker\s*/gi, '')
      .trim();
    const views = entry.getElementsByTagName('media:statistics')[0]?.getAttribute('views')
      || '0';
    return id ? { id, title, views } : null;
  }).filter(Boolean);
}

function ShortsSlider() {
  const [shorts, setShorts] = useState(FALLBACK_SHORTS.slice(0, 6));

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await fetch(
          `https://api.allorigins.win/raw?url=${encodeURIComponent(FEED_URL)}`
        );
        const xml = await res.text();
        const parsed = parseFeed(xml);
        if (mounted && parsed.length > 0) setShorts(parsed.slice(0, 6));
      } catch {
        // keep fallback
      }
    };
    load();
    return () => { mounted = false; };
  }, []);

  // Repeat until one group is wider than the screen, then duplicate for a seamless loop
  const copies = Math.max(4, Math.ceil(18 / Math.max(shorts.length, 1)));
  const group = Array.from({ length: copies }, () => shorts).flat();
  const loop = [...group, ...group];

  return (
    <div className="shorts-slider animate-in delay-2">
      <div className="shorts-slider-label">
        <FaYoutube />
        Latest Shorts
      </div>
      <div className="shorts-track-wrap">
        <div className="shorts-track">
          {loop.map((short, i) => (
            <a
              key={`${short.id}-${i}`}
              href={`https://www.youtube.com/shorts/${short.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="shorts-card"
              title={short.title}
            >
              <img
                src={`https://i.ytimg.com/vi/${short.id}/oar2.jpg`}
                alt=""
                className="shorts-thumb"
                loading="lazy"
              />
              <div className="shorts-card-overlay">
                <span className="shorts-play" />
                <span className="shorts-views">
                  <HiEye />
                  {formatViews(short.views)}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ShortsSlider;
